module.exports = [{"type":"title","text":"2024-09-29"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：Websocket行情推送，增加推送頻率說明。"},{"type":"html","text":"永續U本位：Websocket訂閱，每個IP最多可以連接240個websocket"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-09-23.json
// module id = nNlN
// module chunks = 3